import { render, staticRenderFns } from "./back-link.vue?vue&type=template&id=2e5d1d2a&scoped=true&lang=pug"
import script from "./back-link.vue?vue&type=script&lang=ts"
export * from "./back-link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d1d2a",
  null
  
)

export default component.exports